import { render, staticRenderFns } from "./MyInfoWebpart.vue?vue&type=template&id=64192730"
import script from "./MyInfoWebpart.ts?vue&type=script&lang=ts&external"
export * from "./MyInfoWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports